import { LimitedAgentProfile, Organization } from "@closerplatform/spinner-openapi";
import { observable, ObservableMap } from "mobx";
import { IShortOrgConfig } from "@fidget/common/models/shortOrgConfig";
import { Credentials } from "../models/credentials";
import { match } from "../utils";
import { StorageSharedStore } from "./storageSharedStore";

// every "nullable" field has `T | undefined` type to not lose fields during json (de)serialization
export interface SharedPopupState {
  org: Organization;
  roomId?: string;
  credentials?: Credentials;
  agents: ObservableMap<string, LimitedAgentProfile>;
  assignedAgent?: LimitedAgentProfile;
  orgLogoUrl?: string;
  orgCoverUrl?: string;
  callsDisabled?: boolean;
  orgConfig?: IShortOrgConfig;
}

export function isSharedPopupState(state: any): state is SharedPopupState {
  return match(state, defaultSharedPopupState);
}

const defaultSharedPopupState: SharedPopupState = {
  org: { id: "", name: "", color: "" },
  roomId: undefined,
  credentials: undefined,
  agents: observable(new Map()),
  assignedAgent: undefined,
  orgLogoUrl: undefined,
  orgCoverUrl: undefined,
  callsDisabled: undefined,
  orgConfig: undefined
};

export class SharedPopupStoreClass extends StorageSharedStore<SharedPopupState> {
  @observable
  state: SharedPopupState;
  defaultState: SharedPopupState;

  constructor() {
    super(defaultSharedPopupState);
    this.defaultState = defaultSharedPopupState;
    this.state = { ...defaultSharedPopupState };
  }
}

// wholy sh...

// decorate(LimitedAgentProfile, {
//   firstName: observable,
//   presence: observable,
//   isActive: observable,
//   avatarUrl: observable,
//   isBot: observable
// });
